import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-09dba120"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "study-material-detail-content"
};
const _hoisted_2 = {
  class: "content-header"
};
const _hoisted_3 = {
  class: "header-title"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("hr", {
  class: "divider-line"
}, null, -1));
const _hoisted_5 = ["innerHTML"];
import { ref, watch } from "vue";
import { marked } from "marked";
import { FileTextOutlined } from '@ant-design/icons-vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'StudyMaterialDetailContent',
  props: {
    materialDetail: {}
  },
  setup(__props) {
    const formatterContent = ref('');
    const props = __props;
    watch([() => props.materialDetail], ([newVal]) => {
      if (newVal && newVal.detailContent) {
        const content = marked.parse(newVal.detailContent);
        formatterContent.value = content;
      } else {
        formatterContent.value = '<p style="color:#999;text-align:center;padding:200px 0 40px;font-size:14px;">暂无详情内容</p>';
      }
    });
    return (_ctx, _cache) => {
      const _directive_highlight = _resolveDirective("highlight");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("h2", _hoisted_3, [_createVNode(_unref(FileTextOutlined), {
        class: "header-icon"
      }), _createTextVNode(" 资料详情 ")])]), _hoisted_4, _withDirectives(_createElementVNode("div", {
        class: "markdown-body",
        innerHTML: formatterContent.value
      }, null, 8, _hoisted_5), [[_directive_highlight]])]);
    };
  }
});